import { makeObservable, observable, action } from "mobx"
import { queryAuthPackList } from "utils/api";

// 订阅管理store
export default class PermissionStore {
  tableData = []
  constructor() {
    makeObservable(this, {
        tableData: observable,
        queryAuthPackList: action
    })
  }
  async queryAuthPackList(data) {
    const res = await queryAuthPackList(data)
    const resDataArray = [];
    if(res.data.success && res.data.result.length !== 0){
        res.data.result.forEach((item ,index) => {
            const resData = {};
            resData.authPackName = item.authPackName;
            resData.authPackDesc = item.authPackDesc;
            //resData.handle = <div className="app_action"><span className="per_detail" onClick={handleDetail.bind(this,item.authPackId)}>权限详情</span> <span className="per_space">|</span> <span className="per_help">对接帮助</span></div>;
            resData.key='permissiondata'+index;
            resDataArray.push(resData);
            return resDataArray;
        });
        this.tableData = [ ...resDataArray ]
    }else if(res.data.success && (res.data.result === undefined || res.data.result === null)){
        this.tableData = []
    }
  }
}